import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent, ref } from 'vue';
import dayjs from 'dayjs';
import { Toast } from 'vant';
export default defineComponent({
  name: 'CDateSelect',
  emits: ['confirm-date'],
  props: {
    backgroundColor: {
      type: String,
      default: '#ffffff'
    },
    arrowColor: {
      type: String,
      default: '#4372f6'
    },
    textColor: {
      type: String,
      default: '#4372f6'
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var formatDate = function formatDate(date) {
      return dayjs(date).format('YYYY/MM');
    };
    var calendarRef = ref(null);
    var date = ref(dayjs().format('YYYY/MM'));
    var show = ref(false);
    var maxDate = ref(new Date());
    var minDate = ref(new Date(dayjs().subtract(7, 'year').format('YYYY/MM')));
    var confirmDate = function confirmDate(value) {
      show.value = false;
      date.value = formatDate(value);
      // emit('confirm-date', date.value)
      emit('confirm-date', value);
    };
    var showCalendar = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function showCalendar() {
        return _ref2.apply(this, arguments);
      };
    }();
    var preClick = function preClick() {
      var _calendarRef$value;
      if (date.value <= formatDate(minDate.value)) {
        Toast('已经到可查询日期下限');
        return;
      }
      // eslint-disable-next-line
      date.value = dayjs(date.value).subtract(1, 'month').format('YYYY/MM');
      (_calendarRef$value = calendarRef.value) === null || _calendarRef$value === void 0 || _calendarRef$value.reset(new Date(date.value));
      emit('confirm-date', date.value);
    };
    var nextClick = function nextClick() {
      var _calendarRef$value2;
      if (date.value >= formatDate(maxDate.value)) {
        Toast('不能查询未来日期');
        return;
      }
      date.value = dayjs(date.value).add(1, 'month').format('YYYY/MM');
      (_calendarRef$value2 = calendarRef.value) === null || _calendarRef$value2 === void 0 || _calendarRef$value2.reset(new Date(date.value));
      emit('confirm-date', date.value);
    };
    return {
      calendarRef: calendarRef,
      date: date,
      show: show,
      showCalendar: showCalendar,
      confirmDate: confirmDate,
      preClick: preClick,
      nextClick: nextClick,
      maxDate: maxDate,
      minDate: minDate
    };
  }
});